import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppId } from '../context/AppIdContext';
import '../style/speakSearch.css';
import Header from '../component/header';
import WhatsappSlipButton from '../component/WhatsappSlipButton';
import PracharButton from '../component/PracharButton';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const Phonebook = () => {
    // --- State ---
    const [voters, setVoters] = useState([]);
    const [loading, setLoading] = useState(false);
    const [cardSearchTerm, setCardSearchTerm] = useState("");
    const [filterStatus, setFilterStatus] = useState('all'); // 'all', 'available', 'not_available', 'pending'

    // --- Bulk Send Popup State ---
    const [isBulkSendPopupOpen, setIsBulkSendPopupOpen] = useState(false);

    // --- Pagination State ---
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50;

    // --- Filter Dropdown State ---
    const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);

    // --- Context & Router ---
    const { appId, language, userId, whtspApi, wtspDeviceId } = useAppId(); // ✅ ADDED whtspApi and wtspDeviceId
    const location = useLocation();
    const navigate = useNavigate();

    const passedUserId = location.state?.userId;
    const passedDate = location.state?.user_id;
    const name = location.state?.userName;
    const targetUserId = passedUserId || passedDate || userId;

    const lang = language || 'en';

    // Helper function to convert Status 'D', 'C', 'P', 'N' to Full Form
    const getStatusFullForm = (statusCode) => {
        switch (statusCode?.toUpperCase()) {
            case 'D': return 'Doubtful';
            case 'C': return "Can't Say";
            case 'P': return 'Positive';
            case 'N': return 'Negative';
            default: return statusCode || 'Voted';
        }
    };

    const t = {
        en: {
            pageTitle: (name ? name : "My") + " Phonebook",
            pageSubtitle: "Overview of members in your contact group.",
            filterPlaceholder: "Filter members by name...",
            loadingData: "Loading Data...",
            noVoters: "No members found in this group.",
            noMatching: "No matching names found.",
            fatherHusband: "F/S :",
            serialNo: "Sr No. :",
            mobile: "Mobile :",
            idCardNo: "ID Card No :",
            boothNo: "Booth No :",
            houseNo: "House No :",
            pollingLoc: "Voting Loc :",
            call: "Call",
            text: "Text",
            slip: "Slip",
            prachar: "Prachar",
            print: "Print",
            family: "Family",
            address: "Address :",
            addSurvey: "Add Survey",
            filterAll: "All",
            filterAvailable: "Available",
            filterNotAvailable: "Not Available",
            filterPending: "Pending",
            editMobileTitle: "Update Mobile Number",
            mobilePlaceholder: "Enter 10-digit mobile number",
            mobileErrorLength: "Mobile number must be 10 digits",
            mobileErrorStart: "Number must start with 6, 7, 8, or 9",
            cancel: "Cancel",
            save: "Save",
            saving: "Saving...",
            mobileUpdateSuccess: "Mobile number updated successfully!",
            mobileUpdateFailed: "Failed to update mobile number.",
            mobileUpdateError: "An error occurred while updating the mobile number.",
            mobileNotAvailable: "Mobile number is not available for this voter.",
            addressNotAvailable: "Address not available!",
            bulkSend: "Bulk Send",
            bulkSendTitle: "Bulk Send Options",
            sendToAll: "Send to All",
            sendToRemaining: "Send to Remaining",
            totalCount: "Total :"
        },
        hi: {
            pageTitle: (name ? name : "मेरी फ़ोनबुक"),
            pageSubtitle: "आपके संपर्क समूह के सदस्यों का विवरण।",
            filterPlaceholder: "नाम से प्रदर्शित परिणाम फ़िल्टर करें...",
            loadingData: "डेटा लोड हो रहा है...",
            noVoters: "इस समूह में कोई सदस्य नहीं मिला।",
            noMatching: "मेल खाने वाले कोई नाम नहीं मिले।",
            fatherHusband: "पिता/पति :",
            serialNo: "क्रमांक :",
            mobile: "मोबाइल :",
            idCardNo: "पहचान पत्र नं.:",
            boothNo: "बूथ नं :",
            houseNo: "घर नं :",
            pollingLoc: "मतदान स्थान :",
            call: "कॉल",
            text: "मैसेज",
            slip: "पर्ची",
            prachar: "प्रचार",
            print: "प्रिंट",
            family: "परिवार",
            addSurvey: "सर्वेक्षण जोड़ें",
            filterAll: "सभी",
            filterAvailable: "उपलब्ध",
            filterNotAvailable: "अनुपलब्ध",
            filterPending: "लंबित",
            editMobileTitle: "मोबाइल नंबर अपडेट करें",
            mobilePlaceholder: "10 अंकों का मोबाइल नंबर दर्ज करें",
            mobileErrorLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
            mobileErrorStart: "नंबर 6, 7, 8, या 9 से शुरू होना चाहिए",
            cancel: "रद्द करें",
            save: "सेव करें",
            saving: "सेव हो रहा है...",
            mobileUpdateSuccess: "मोबाइल नंबर सफलतापूर्वक अपडेट हो गया!",
            mobileUpdateFailed: "मोबाइल नंबर अपडेट करने में विफल।",
            mobileUpdateError: "मोबाइल नंबर अपडेट करते समय एक त्रुटि हुई।",
            mobileNotAvailable: "इस मतदाता के लिए मोबाइल नंबर उपलब्ध नहीं है।",
            addressNotAvailable: "पता उपलब्ध नहीं है!",
            bulkSend: "बल्क भेजें",
            bulkSendTitle: "बल्क सेंड विकल्प",
            sendToAll: "सभी को भेजें",
            sendToRemaining: "बाकी को भेजें",
            totalCount: "कुल :"
        },
        gu: {
            pageTitle: (name ? name : "મારી ફોનબુક"),
            pageSubtitle: "તમારા સંપર્ક જૂથના સભ્યોની ઝાંખી.",
            filterPlaceholder: "સભ્યોને નામથી ફિલ્ટર કરો...",
            loadingData: "ડેટા લોડ થઈ રહ્યો છે...",
            noVoters: "આ જૂથમાં કોઈ સભ્ય મળ્યા નથી.",
            noMatching: "કોઈ મેળ ખાતું નામ મળ્યું નથી.",
            fatherHusband: "પિતા/પતિ :",
            serialNo: "ક્રમાંક :",
            mobile: "મોબાઇલ :",
            idCardNo: "ઓળખ કાર્ડ નં :",
            boothNo: "બૂથ નં :",
            houseNo: "ઘર નં :",
            pollingLoc: "મતદાન સ્થળ :",
            call: "કૉલ",
            text: "સંદેશ",
            slip: "સ્લિપ",
            prachar: "પ્રચાર",
            print: "પ્રિન્ટ",
            family: "કુટુંબ",
            address: "સરનામું :",
            addSurvey: "સર્વે ઉમેરો",
            filterAll: "બધા",
            filterAvailable: "ઉપલબ્ધ",
            filterNotAvailable: "અનુપલબ્ધ",
            filterPending: "બાકી",
            editMobileTitle: "મોબાઇલ નંબર અપડેટ કરો",
            mobilePlaceholder: "10 અંકોનો મોબાઇલ નંબર દાખલ કરો",
            mobileErrorLength: "મોબાઇલ નંબર 10 અંકોનો હોવો જોઈએ",
            mobileErrorStart: "નંબર 6, 7, 8, અથવા 9 થી શરૂ થવો જોઈએ",
            cancel: "રદ કરો",
            save: "સેવ કરો",
            saving: "સેવ થઈ રહ્યું છે...",
            mobileUpdateSuccess: "મોબાઇલ નંબર સફળતાપૂર્વક અપડેટ થયો!",
            mobileUpdateFailed: "મોબાઇલ નંબર અપડેટ કરવામાં નિષ્ફળ.",
            mobileUpdateError: "મોબાઇલ નંબર અપડેટ કરતી વખતે એક ભૂલ આવી.",
            mobileNotAvailable: "આ મતદાર માટે મોબાઇલ નંબર ઉપલબ્ધ નથી.",
            addressNotAvailable: "સરનામું ઉપલબ્ધ નથી!",
            bulkSend: "બલ્ક મોકલો",
            bulkSendTitle: "બલ્ક સેન્ડ વિકલ્પો",
            sendToAll: "બધાને મોકલો",
            sendToRemaining: "બાકીનાને મોકલો",
            totalCount: "કુલ :"
        }
    };

    const txt = t[lang];
    // --- Edit Mobile State ---
    const [isEditMobileOpen, setIsEditMobileOpen] = useState(false);
    const [editingVoter, setEditingVoter] = useState(null);
    const [newMobile, setNewMobile] = useState('');
    const [isSavingMobile, setIsSavingMobile] = useState(false);



    // --- Edit Mobile API Call ---
    const handleUpdateMobile = async () => {
        if (!newMobile || newMobile.length !== 10) {
            alert(txt.mobileErrorLength);
            return;
        }

        setIsSavingMobile(true);
        try {
            const payload = {
                app_id: appId?.toString(),
                voter_id: editingVoter.idcard_no,
                mobile_no: newMobile,
                modify_by: userId?.toString() || "1"
            };

            const response = await axios.post(`${BASE_URL}/api/upd_voter_mobile`, payload);

            if (response.data.success || response.data.Success === "1") {
                alert(txt.mobileUpdateSuccess);
                setVoters(prev => prev.map(v =>
                    v.id === editingVoter.id ? { ...v, contact_no: newMobile } : v
                ));
                setIsEditMobileOpen(false);
            } else {
                alert(txt.mobileUpdateFailed);
            }
        } catch (error) {
            console.error("Error updating mobile:", error);
            alert(txt.mobileUpdateError);
        } finally {
            setIsSavingMobile(false);
        }
    };



    const fetchVoters = async () => {
        if (!appId || !userId) return;
        setLoading(true);
        try {
            const response = await axios.post(
                `${BASE_URL}/api/dis_contact_group_member`,
                {
                    app_id: appId,
                    user_id: targetUserId
                }
            );

            if (response.data.success && Array.isArray(response.data.data.result)) {
                setVoters(response.data.data.result);
            } else {
                setVoters([]);
            }
        } catch (error) {
            console.error("Error fetching voters:", error);
            setVoters([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!appId) {
            navigate("/");
            return;
        }
        fetchVoters();
    }, [appId, userId]);

    useEffect(() => {
        setCurrentPage(1);
    }, [cardSearchTerm, filterStatus]);

    // Filter logic with status filter
    const filteredVoters = voters.filter((voter) => {
        // Name search filter
        let matchesSearch = true;
        if (cardSearchTerm) {
            const fName = voter.eng_f_name ? voter.eng_f_name.toLowerCase() : "";
            const sName = voter.eng_surname ? voter.eng_surname.toLowerCase() : "";
            const fullName = `${fName} ${sName}`.trim();
            matchesSearch = fullName.includes(cardSearchTerm.toLowerCase());
        }

        // Status filter
        let matchesStatus = true;
        if (filterStatus === 'available') {
            matchesStatus = voter.voter_available === true;
        } else if (filterStatus === 'not_available') {
            matchesStatus = voter.voter_available === false;
        } else if (filterStatus === 'pending') {
            matchesStatus = voter.voter_available === null;
        }

        return matchesSearch && matchesStatus;
    });

    // --- Pagination Logic ---
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentVoters = filteredVoters.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredVoters.length / itemsPerPage);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxVisibleButtons = 5;
        if (totalPages <= maxVisibleButtons) {
            for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
        } else {
            pageNumbers.push(1);
            let startPage = Math.max(2, currentPage - 1);
            let endPage = Math.min(totalPages - 1, currentPage + 1);
            if (currentPage <= 3) endPage = 4;
            if (currentPage >= totalPages - 2) startPage = totalPages - 3;
            if (startPage > 2) pageNumbers.push('...');
            for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
            if (endPage < totalPages - 1) pageNumbers.push('...');
            pageNumbers.push(totalPages);
        }
        return pageNumbers;
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isFilterDropdownOpen && !event.target.closest('.filter-dropdown-container')) {
                setIsFilterDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isFilterDropdownOpen]);

    // Get filter button text based on current filter
    const getFilterButtonText = () => {
        switch (filterStatus) {
            case 'available': return txt.filterAvailable;
            case 'not_available': return txt.filterNotAvailable;
            case 'pending': return txt.filterPending;
            default: return txt.filterAll;
        }
    };

    // --- WhatsApp Message Generation Logic ---
    const handleWhatsAppShare = async (voter) => {
        if (!voter.contact_no) {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_wtsp`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('સ્રી', 'સ્ત્રી')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');
                if (mobile.length === 10) mobile = '91' + mobile;

                window.open(`https://wa.me/${mobile}?text=${encodedMessage}`, '_blank');

            } else {
                alert("Could not fetch family details.");
            }
        } catch (error) {
            console.error("Error generating WhatsApp slip:", error);
            alert("Error generating message.");
        }
    };

    // --- SMS Message Generation Logic ---
    const handleSmsShare = async (voter) => {
        if (!voter.contact_no) {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_sms`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('સ્રી', 'સ્ત્રી')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');

                window.location.href = `sms:${mobile}?body=${encodedMessage}`;

            } else {
                alert("Could not fetch family details for SMS.");
            }
        } catch (error) {
            console.error("Error generating SMS slip:", error);
            alert("Error generating SMS message.");
        }
    };

    return (
        <div className='app-container p-4 pb-5'>

            <Header title={txt.pageTitle} />

            {/* Mobile Number Edit Modal */}
            {isEditMobileOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }} onClick={() => setIsEditMobileOpen(false)}>
                    <div className="slide-up-element" style={{ background: 'white', padding: '24px', borderRadius: '16px', width: '90%', maxWidth: '350px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }} onClick={(e) => e.stopPropagation()}>
                        <h4 style={{ margin: '0 0 16px 0', fontSize: '18px', color: '#0f172a', fontWeight: '700' }}>{txt.editMobileTitle}</h4>
                        <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#64748b' }}>{editingVoter?.eng_f_name} {editingVoter?.eng_surname}</p>

                        <div style={{ marginBottom: '24px' }}>
                            <input
                                type="tel"
                                maxLength="10"
                                value={newMobile}
                                onChange={(e) => setNewMobile(e.target.value.replace(/[^0-9]/g, ''))}
                                style={{
                                    width: '100%',
                                    padding: '12px 16px',
                                    border: (newMobile && !/^[6-9]\d{9}$/.test(newMobile) && newMobile.length === 10) ? '1px solid #ef4444' : '1px solid #cbd5e1',
                                    borderRadius: '10px',
                                    fontSize: '15px',
                                    outline: 'none',
                                    boxSizing: 'border-box'
                                }}
                                placeholder={txt.mobilePlaceholder}
                                autoFocus
                            />
                            {newMobile && newMobile.length > 0 && !/^[6-9]\d{9}$/.test(newMobile) && (
                                <div style={{ fontSize: '11px', color: '#ef4444', marginTop: '6px', fontWeight: '500' }}>
                                    {newMobile.length < 10 ? txt.mobileErrorLength : txt.mobileErrorStart}
                                </div>
                            )}
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                            <button
                                onClick={() => setIsEditMobileOpen(false)}
                                style={{ padding: '10px 16px', background: 'white', color: '#475569', border: '1px solid #cbd5e1', borderRadius: '10px', cursor: 'pointer', fontWeight: '600' }}
                            >
                                {txt.cancel}
                            </button>
                            <button
                                onClick={handleUpdateMobile}
                                disabled={isSavingMobile || !/^[6-9]\d{9}$/.test(newMobile)}
                                style={{
                                    padding: '10px 20px',
                                    background: (!/^[6-9]\d{9}$/.test(newMobile)) ? '#94a3b8' : '#2563eb',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '10px',
                                    cursor: (!/^[6-9]\d{9}$/.test(newMobile)) ? 'not-allowed' : 'pointer',
                                    fontWeight: '600'
                                }}
                            >
                                {isSavingMobile ? txt.saving : txt.save}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* --- NEW: Bulk Send Option Modal --- */}
            {isBulkSendPopupOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }} onClick={() => setIsBulkSendPopupOpen(false)}>
                    <div className="slide-up-element" style={{ background: 'white', padding: '32px', borderRadius: '20px', width: '90%', maxWidth: '420px', position: 'relative', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)' }} onClick={(e) => e.stopPropagation()}>
                        
                        {/* Cross Icon for Closing */}
                        <button
                            onClick={() => setIsBulkSendPopupOpen(false)}
                            style={{ 
                                position: 'absolute', 
                                top: '16px', 
                                right: '16px', 
                                background: 'transparent', 
                                border: 'none', 
                                cursor: 'pointer', 
                                color: '#94a3b8', 
                                padding: '4px', 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                borderRadius: '50%', 
                                transition: 'background 0.2s' 
                            }}
                            onMouseOver={(e) => e.currentTarget.style.background = '#f1f5f9'}
                            onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}
                        >
                            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>

                        <h4 style={{ margin: '0 0 24px 0', fontSize: '20px', color: '#0f172a', fontWeight: '800', textAlign: 'center' }}>{txt.bulkSendTitle}</h4>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <button
                                onClick={() => {
                                    setIsBulkSendPopupOpen(false);
                                    navigate('/wtsp_bulk_slip_send', { state: { voters: filteredVoters, type: 'all' } });
                                }}
                                style={{ padding: '14px 20px', background: '#2563eb', color: 'white', border: 'none', borderRadius: '12px', cursor: 'pointer', fontWeight: '600', fontSize: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', transition: 'transform 0.2s' }}
                                onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                            >
                                <span>{txt.sendToAll}</span>
                                <span style={{ background: 'rgba(255,255,255,0.2)', padding: '4px 10px', borderRadius: '12px' }}>{filteredVoters.length}</span>
                            </button>
                            <button
                                onClick={() => {
                                    setIsBulkSendPopupOpen(false);
                                    const remainingVoters = filteredVoters.filter(v => v.slip_send == 0 || !v.slip_send);
                                    navigate('/wtsp_bulk_slip_send', { state: { voters: remainingVoters, type: 'remaining' } });
                                }}
                                style={{ padding: '14px 20px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '12px', cursor: 'pointer', fontWeight: '600', fontSize: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', transition: 'transform 0.2s' }}
                                onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                            >
                                <span>{txt.sendToRemaining}</span>
                                <span style={{ background: 'rgba(255,255,255,0.3)', padding: '4px 10px', borderRadius: '12px', color: '#fff' }}>{filteredVoters.filter(v => v.slip_send == 0 || !v.slip_send).length}</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Filter Row with Search and Filter Button */}
            <div className="filter-container mt-3">
                <div className="search-wrapper">
                    <svg className="search-icon-main" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                    <input
                        className="search-input-modern"
                        type="text"
                        placeholder={txt.filterPlaceholder}
                        value={cardSearchTerm}
                        onChange={(e) => setCardSearchTerm(e.target.value)}
                    />
                </div>

                {/* Right Side Group Container for Bulk Send and Dropdown */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginLeft: 'auto', flexWrap: 'wrap' }}>
                    <div className="count-display-modern slide-up-element">
                        <span className="count-label">{txt.totalCount}</span>
                        <span className="count-number">{filteredVoters.length}</span>
                    </div>

                    {/* ✅ NEW BULK SEND BUTTON */}
                    {Number(whtspApi) === 1 && wtspDeviceId && (
                        <button
                            className="btn-bulk-send slide-up-element"
                            onClick={() => setIsBulkSendPopupOpen(true)}
                        >
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: '6px'}}>
                                <line x1="22" y1="2" x2="11" y2="13"></line>
                                <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                            </svg>
                            {txt.bulkSend}
                        </button>
                    )}

                    {/* Filter Dropdown Button */}
                    <div className="filter-dropdown-container">
                        <button
                            className="filter-btn"
                            onClick={() => setIsFilterDropdownOpen(!isFilterDropdownOpen)}
                        >
                            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <polygon points="22 3 2 3 10 13 10 21 14 18 14 13 22 3" />
                            </svg>
                            {getFilterButtonText()}
                            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <polyline points="6 9 12 15 18 9" />
                            </svg>
                        </button>

                        {isFilterDropdownOpen && (
                            <div className="filter-dropdown-menu">
                                <button
                                    className={`filter-option ${filterStatus === 'all' ? 'active' : ''}`}
                                    onClick={() => { setFilterStatus('all'); setIsFilterDropdownOpen(false); }}
                                >
                                    {txt.filterAll}
                                </button>
                                <button
                                    className={`filter-option ${filterStatus === 'available' ? 'active' : ''}`}
                                    onClick={() => { setFilterStatus('available'); setIsFilterDropdownOpen(false); }}
                                >
                                    <span className="filter-dot available-dot"></span>
                                    {txt.filterAvailable}
                                </button>
                                <button
                                    className={`filter-option ${filterStatus === 'not_available' ? 'active' : ''}`}
                                    onClick={() => { setFilterStatus('not_available'); setIsFilterDropdownOpen(false); }}
                                >
                                    <span className="filter-dot not-available-dot"></span>
                                    {txt.filterNotAvailable}
                                </button>
                                <button
                                    className={`filter-option ${filterStatus === 'pending' ? 'active' : ''}`}
                                    onClick={() => { setFilterStatus('pending'); setIsFilterDropdownOpen(false); }}
                                >
                                    <span className="filter-dot pending-dot"></span>
                                    {txt.filterPending}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {loading ? (
                <div className="loader-wrapper text-center p-5">
                    <div className="spinner"></div>
                    <p className="mt-3">{txt.loadingData}</p>
                </div>
            ) : (
                <>
                    <div style={{ marginBottom: filteredVoters.length > itemsPerPage ? '80px' : '0' }}>
                        <div className="row g-4">
                            {currentVoters.length > 0 ? (
                                currentVoters.map((voter, index) => (
                                    <div className="col-12 col-md-6 col-lg-4" key={voter.id || index}>
                                        <div className="voter-card-clean h-100">
                                            {/* Header with Conditional Badge/Button */}
                                            <div className="voter-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <div>
                                                    <span className="serial-number">{index + 1 + indexOfFirstItem}.</span>
                                                    <span className="voter-name-bold ms-2">{voter.eng_f_name} {voter.eng_surname}</span>
                                                </div>
                                                <div>
                                                    {voter.voter_available === null && (
                                                        <button
                                                            className="btn-add-survey"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                navigate('/voter_survey_form', { state: { voter: voter } });
                                                            }}
                                                        >
                                                            + {txt.addSurvey}
                                                        </button>
                                                    )}
                                                    {voter.voter_available === true && (
                                                        <span
                                                            className="badge-status status-positive"
                                                        >
                                                            {getStatusFullForm(voter.voter_status)}
                                                        </span>
                                                    )}
                                                    {voter.voter_available === false && (
                                                        <span
                                                            className="badge-status status-negative"
                                                        >
                                                            {voter.not_available_reason || 'Not Available'}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="voter-body position-relative">
                                                <div
                                                    className="map-icon-wrapper"
                                                    style={{ cursor: 'pointer', zIndex: 10 }}
                                                    title="View on Google Maps"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        const address = voter.eng_localityid;
                                                        if (address && address !== "N/A") {
                                                            window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`, '_blank');
                                                        } else {
                                                            alert("Address not available!");
                                                        }
                                                    }}
                                                >
                                                    <img src="https://upload.wikimedia.org/wikipedia/commons/a/aa/Google_Maps_icon_%282020%29.svg" alt="Map" width="15" />
                                                </div>
                                                <div className="info-row"><span className="label">{txt.fatherHusband}</span><span className="value">{voter.eng_m_name || "N/A"}</span></div>
                                                <div className="info-row"><span className="label">{txt.address}</span><span className="value">{voter.eng_localityid || "N/A"}</span></div>
                                                <div className="info-row"><span className="label">{txt.serialNo}</span><span className="value">{voter.slnoinpart}</span></div>
                                                <div className="info-row" style={{ display: 'flex', alignItems: 'center' }}>
                                                    <span className="label">{txt.mobile}</span>
                                                    <span className="value mobile-value" style={{ flexGrow: 1 }}>{voter.contact_no || "N/A"}</span>
                                                    <svg
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setEditingVoter(voter);
                                                            setNewMobile(voter.contact_no || '');
                                                            setIsEditMobileOpen(true);
                                                        }}
                                                        style={{ cursor: 'pointer', color: '#f59e0b', width: '18px', height: '18px', flexShrink: 0 }}
                                                        fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"
                                                    >
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                    </svg>
                                                </div>
                                                <div className="info-row"><span className="label">{txt.idCardNo}</span><span className="value">{voter.idcard_no || "N/A"}</span></div>
                                                <div className="info-row"><span className="label">{txt.boothNo}</span><span className="value">{voter.part_no || voter.booth_no || "N/A"}</span></div>
                                                <div className="info-row"><span className="label">{txt.houseNo}</span><span className="value">{voter.eng_house_no || "N/A"}</span></div>
                                                <div className="info-row"><span className="label">{txt.pollingLoc}</span><span className="value">{voter.eng_polling_location || "-"}</span></div>
                                            </div>

                                            <div className="voter-actions">
                                                <ActionButton icon="📞" color="#0ea5e9" label={txt.call}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        if (!voter.contact_no || voter.contact_no === "N/A" || voter.contact_no === "-" || voter.contact_no === "") {
                                                            alert("Mobile number is not available for this voter.");
                                                        }
                                                        else {
                                                            window.open(`tel:${voter.contact_no}`, '_blank');
                                                        }
                                                    }}

                                                />
                                                <ActionButton icon="✉️" color="#f59e0b" label={txt.text} onClick={() => handleSmsShare(voter)} />
                                                <WhatsappSlipButton voter={voter} />
                                                <ActionButton
                                                    icon="🖨"
                                                    color="#f97316"
                                                    label={txt.print}
                                                    onClick={() => navigate('/printer', { state: { voter_id: voter.id } })}
                                                />
                                                <PracharButton voter={voter} />
                                                <ActionButton icon="👨‍👩‍👧" color="#fbbf24" label={txt.family} onClick={() => navigate('/dis_family_member', { state: { voter_id: voter.id } })} />
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="text-center text-muted p-5 w-100">{voters.length === 0 ? txt.noVoters : txt.noMatching}</div>
                            )}
                        </div>

                        {/* --- PAGINATION CONTROLS --- */}
                        {!loading && filteredVoters.length > itemsPerPage && (
                            <div className="pagination-wrapper fixed-bottom-pagination">
                                <div className="pagination-content">
                                    <button className="pagination-nav-btn" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                                        <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
                                    </button>
                                    <div className="page-numbers">
                                        {getPageNumbers().map((number, index) => (
                                            <React.Fragment key={index}>
                                                {number === '...' ? (
                                                    <span className="page-dots">...</span>
                                                ) : (
                                                    <button className={`page-num-btn ${currentPage === number ? 'active' : ''}`} onClick={() => paginate(number)}>{number}</button>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </div>
                                    <button className="pagination-nav-btn" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                                        <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}

            <style jsx>{`
                .pb-total-card {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    background: linear-gradient(135deg, #eff6ff 0%, #ffffff 70%);
                    border: 1px solid #dbeafe;
                    border-radius: 10px;
                    padding: 10px 16px;
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
                    flex-shrink: 0;
                    white-space: nowrap;
                    box-sizing: border-box;
                    min-height: 42px;
                }
                .pb-total-label {
                    font-size: 13px;
                    font-weight: 600;
                    color: #64748b;
                    line-height: 1;
                }
                .pb-total-badge {
                    font-size: 13px;
                    font-weight: 800;
                    color: #1d4ed8;
                    line-height: 1;
                }
                .filter-container { 
                    display: flex; 
                    flex-direction: row;
                    justify-content: space-between; 
                    align-items: center; 
                    gap: 12px;
                    margin-bottom: 24px; 
                }
                
                /* --- COUNT DISPLAY --- */
                .count-display-modern {
                    display: inline-flex;
                    align-items: center;
                    background: #eff6ff;
                    padding: 8px 16px;
                    border-radius: 12px;
                    border: 1px solid #bfdbfe;
                    box-shadow: 0 2px 4px rgba(37, 99, 235, 0.05);
                    gap: 8px;
                }
                .count-label {
                    color: #1e40af;
                    font-weight: 600;
                    font-size: 15px;
                }
                .count-number {
                    background: transparent;
                    color: #1d4ed8;
                    font-weight: 800;
                    font-size: 16px;
                }

                .search-wrapper { 
                    position: relative; 
                    flex: 1;
                    max-width: 450px; 
                }
                .search-icon-main { 
                    position: absolute; 
                    left: 14px; 
                    top: 50%; 
                    transform: translateY(-50%); 
                    color: #94a3b8; 
                    width: 18px; 
                    height: 18px; 
                }
                .search-input-modern { 
                    width: 100%; 
                    padding: 12px 16px 12px 42px; 
                    border: 1px solid #e2e8f0; 
                    border-radius: 10px; 
                    font-size: 14px; 
                    color: #1e293b; 
                    outline: none; 
                    transition: all 0.2s ease; 
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05); 
                }
                .search-input-modern:focus { 
                    border-color: #2563eb; 
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1); 
                }

                /* ✅ NEW BULK SEND BUTTON STYLES */
                .btn-bulk-send {
                    display: flex;
                    align-items: center;
                    background: linear-gradient(135deg, #2563eb, #1d4ed8);
                    color: white;
                    border: none;
                    padding: 10px 18px;
                    border-radius: 10px;
                    font-size: 13px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
                    white-space: nowrap;
                    flex-shrink: 0;
                }
                .btn-bulk-send:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 16px rgba(37, 99, 235, 0.3);
                }

                /* Filter Dropdown Styles */
                .filter-dropdown-container {
                    position: relative;
                    flex-shrink: 0;
                }
                
                .filter-btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    padding: 10px 16px;
                    background: white;
                    border: 1px solid #e2e8f0;
                    border-radius: 10px;
                    font-size: 13px;
                    font-weight: 600;
                    color: #1e293b;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    white-space: nowrap;
                    width: auto;
                }
                
                .filter-btn:hover {
                    background: #f8fafc;
                    border-color: #cbd5e1;
                }
                
                .filter-dropdown-menu {
                    position: absolute;
                    top: 100%;
                    right: 0;
                    margin-top: 8px;
                    background: white;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
                    min-width: 160px;
                    z-index: 100;
                    overflow: hidden;
                }
                
                .filter-option {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    width: 100%;
                    padding: 10px 16px;
                    border: none;
                    background: white;
                    font-size: 13px;
                    font-weight: 500;
                    color: #334155;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    text-align: left;
                }
                
                .filter-option:hover {
                    background: #f1f5f9;
                }
                
                .filter-option.active {
                    background: #eff6ff;
                    color: #2563eb;
                }
                
                .filter-dot {
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    display: inline-block;
                }
                
                .available-dot {
                    background-color: #22c55e;
                }
                
                .not-available-dot {
                    background-color: #ef4444;
                }
                
                .pending-dot {
                    background-color: #f59e0b;
                }

                .loader-wrapper { 
                    display: flex; 
                    flex-direction: column; 
                    justify-content: center; 
                    align-items: center; 
                    min-height: 50vh; 
                    width: 100%; 
                }
                .spinner { 
                    width: 40px; 
                    height: 40px; 
                    border: 4px solid #E5E7EB; 
                    border-top: 4px solid #2563EB; 
                    border-radius: 50%; 
                    animation: spin 1s linear infinite; 
                    margin-bottom: 12px; 
                }
                @keyframes spin { 
                    0% { transform: rotate(0deg); } 
                    100% { transform: rotate(360deg); } 
                }

                /* Add Survey Button */
                .btn-add-survey {
                    background-color: #3b82f6;
                    color: white;
                    border: none;
                    border-radius: 16px;
                    font-size: 11px;
                    font-weight: 600;
                    padding: 4px 12px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    white-space: nowrap;
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                }

                .btn-add-survey:hover {
                    background-color: #2563eb;
                    transform: translateY(-1px);
                }

                /* Status Badges */
                .badge-status {
                    display: inline-block;
                    border-radius: 16px;
                    font-size: 11px;
                    font-weight: 600;
                    padding: 4px 12px;
                    white-space: nowrap;
                    display: inline-flex;
                    align-items: center;
                }

                .status-positive {
                    background-color: #dcfce7;
                    color: #166534;
                    border: 1px solid #bbf7d0;
                }

                .status-negative {
                    background-color: #fee2e2;
                    color: #991b1b;
                    border: 1px solid #fecaca;
                }

                /* Pagination Styles */
                .fixed-bottom-pagination { 
                    position: fixed; 
                    bottom: 0; 
                    left: 0; 
                    width: 100%; 
                    display: flex; 
                    justify-content: center; 
                    padding: 15px 0 20px 0; 
                    background: transparent; 
                    z-index: 1000;
                }
                .pagination-wrapper { display: flex; justify-content: center; padding: 20px 0; position: sticky; bottom: 20px; z-index: 50; pointer-events: none; }
                .pagination-content { background: white; border: 1px solid #E2E8F0; border-radius: 50px; padding: 8px 16px; display: flex; align-items: center; gap: 10px; box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1); pointer-events: auto; }
                .pagination-nav-btn { display: flex; align-items: center; justify-content: center; width: 36px; height: 36px; border-radius: 50%; background: transparent; border: none; color: #2563EB; cursor: pointer; transition: all 0.2s; }
                .pagination-nav-btn:hover:not(:disabled) { background: #EFF6FF; }
                .pagination-nav-btn:disabled { color: #CBD5E1; cursor: not-allowed; }
                .page-numbers { display: flex; gap: 5px; align-items: center; }
                .page-num-btn { width: 32px; height: 32px; border-radius: 50%; border: 1px solid transparent; background: transparent; color: #475569; font-weight: 600; font-size: 14px; cursor: pointer; transition: all 0.2s; }
                .page-num-btn.active { background-color: #2563EB; color: white; }
                .page-dots { color: #94A3B8; font-weight: bold; padding: 0 4px; }

                /* ANIMATION */
                @keyframes slideInUp { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }
                .slide-up-element { opacity: 0; animation: slideInUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards; }

                /* 🔴 FIX FOR MOBILE */
                @media (max-width: 640px) {
                    .filter-container { 
                        flex-direction: row;
                        align-items: center;
                        gap: 8px;
                        flex-wrap: wrap; /* ✅ Allow wrapping if needed */
                    }
                    .search-wrapper { 
                        max-width: none; 
                        flex: 1;
                        min-width: 120px; /* ✅ Prevent search from becoming too small */
                    }
                    .btn-bulk-send {
                        padding: 8px 12px;
                        font-size: 11px;
                    }
                    .btn-bulk-send svg {
                        width: 14px;
                        height: 14px;
                        margin-right: 4px;
                    }
                    .filter-btn {
                        padding: 8px 12px;
                        font-size: 12px;
                    }
                    .pb-total-card {
                        padding: 8px 12px;
                        min-height: 36px;
                    }
                    .pb-total-label,
                    .pb-total-badge {
                        font-size: 12px;
                    }
                    .filter-dropdown-menu {
                        right: 0;
                        left: auto;
                        min-width: 140px;
                    }
                    
                    .btn-add-survey { 
                        font-size: 10px; 
                        padding: 3px 10px; 
                    }
                    .badge-status { 
                        font-size: 10px; 
                        padding: 3px 10px; 
                    }
                }
            `}</style>
        </div>
    );
};

// Updated ActionButton to accept onClick props
const ActionButton = ({ icon, color, label, link, onClick }) => {
    if (onClick) {
        return (
            <button onClick={onClick} className="action-btn-wrapper" style={{ textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
                <span className="btn-label">{label}</span>
            </button>
        );
    }

    return (
        <a href={link || "#"} className="action-btn-wrapper" style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer">
            <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
            <span className="btn-label">{label}</span>
        </a>
    );
};

export default Phonebook;